export default __webpack_public_path__ + "static/media/july.3f912722.jpg";